const ROLES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
}

export default ROLES_INITIAL_STATE
